export const permissionActionData = [
  {
    name: 'changePermissionInTenant',
    label: 'Update Tenant Permissions',
    args: [],
  },
  {
    name: 'changePermissionInUser',
    label: 'Update User Permissions',
    args: [],
  },
  {
    name: 'changePermissionInUserSettings',
    label: 'Update User Settings Permissions',
    args: [],
  },
];
